import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { StateFormComponent } from '../state-form/state-form.component';
import { DataserviceService } from '../dataservice.service';
import { AppComponent } from '../app.component';
// import { StateInfo } from '../models/state-info.model';

export interface StateInfo {
  id: string;
  name: string;
  providers: string[];
  color: string;
}

@Component({
  selector: 'app-state-list',
  templateUrl: './state-list.component.html',
  styleUrl: './state-list.component.css'
})
export class StateListComponent implements OnInit {
  states: StateInfo[] = [];

  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private dataService: DataserviceService,
    private app: AppComponent
  ) {}

  ngOnInit(): void {
    this.fetchStates();
    console.log(this.states);

    // Sort states alphabetically by name
    this.states.sort((a, b) => a.name.localeCompare(b.name));
  }

  hasPermission(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  fetchStates(): void {
    this.dataService.getData('coverage').subscribe(
      (response) => {
        console.log(response);
        this.states = response;

        // Sort states alphabetically by name after fetching
        this.states.sort((a, b) => a.name.localeCompare(b.name));
      },
      (error) => {
        console.error('Error fetching states:', error);
        this.message.error('Failed to fetch states');
      }
    );
  }

  addState(): void {
    this.openStateModal();
  }

  editState(state: StateInfo): void {
    this.openStateModal(state);
  }

  openStateModal(state?: StateInfo): void {
    const modal = this.modalService.create({
      nzTitle: state ? 'Edit State' : 'Add New State',
      nzContent: StateFormComponent,
      nzMaskClosable: false,
      nzOnOk: (componentInstance) => {
        if (componentInstance.stateForm.valid) {
          return componentInstance.stateForm.value;
        }
        return false;
      }
    });

    // Get the component instance after the modal is created
    const instance = modal.getContentComponent();
    if (instance && state) {
      instance.initialState = state;
    }

    modal.afterClose.subscribe((result: StateInfo | null) => {
      console.log('Modal closed with result:', result);
      if (result) {
        if (state) {
          this.updateState(result);
        } else {
          this.createState(result);
        }
      }
    });
  }

  createState(newState: StateInfo): void {
    this.dataService.postData(newState, 'coverage').subscribe(
      (response) => {
        this.message.success('State added successfully');
        this.fetchStates();
      },
      (error) => {
        console.error('Error adding state:', error);
        this.message.error('Failed to add state');
      }
    );
  }

  updateState(updatedState: StateInfo): void {
    this.dataService.updateData(updatedState, `coverage/${updatedState.id}`).subscribe(
      (response) => {
        this.message.success('State updated successfully');
        this.fetchStates();
      },
      (error) => {
        console.error('Error updating state:', error);
        this.message.error('Failed to update state');
      }
    );
  }

  deleteState(id: string): void {
    console.log('Delete state called with id:', id);
    this.modalService.confirm({
      nzTitle: 'Are you sure you want to delete this state?',
      nzContent: 'This action cannot be undone.',
      nzOnOk: () => {
        this.dataService.deleteData(`coverage/${id}`).subscribe(
          () => {
            this.message.success('State deleted successfully');
            this.fetchStates();
          },
          (error) => {
            console.error('Error deleting state:', error);
            this.message.error('Failed to delete state');
          }
        );
      }
    });
  }
}
